import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { useRef } from 'react'

import { AUTH, MAIN_MENU, NAV_BRAND } from '@/config'
import { PORTAL_TYPE_YF } from '@/config/constants'

import { AuthMenuItem, ProfileMenuItem } from '../../user'

import MainMenuLinksList from './MainMenuLinksList'

const MainMenuLinks = ({ toggleMainMenu }) => {
  const { current: isYF } = useRef(NAV_BRAND.portal_type === PORTAL_TYPE_YF)
  const {
    current: [mainMenuItems, yfCenterMenuItems]
  } = useRef(isYF && MAIN_MENU.length > 3 ? [MAIN_MENU.slice(3), MAIN_MENU.slice(0, 3)] : [MAIN_MENU])

  return (
    <>
      {yfCenterMenuItems &&
        <MainMenuLinksList
          items={yfCenterMenuItems}
          className='navbar-nav yf-navbar-nav-center'
          onClick={toggleMainMenu}
        />}
      <MainMenuLinksList
        items={mainMenuItems}
        className={classnames('navbar-nav', { 'yf-navbar-nav-right': isYF })}
        onClick={toggleMainMenu}
      >
        {AUTH.enabled &&
          (
            <>
              <ProfileMenuItem />
              <AuthMenuItem />
            </>
          )}
      </MainMenuLinksList>
    </>
  )
}

MainMenuLinks.propTypes = {
  toggleMainMenu: PropTypes.func
}

export default MainMenuLinks
